import { toast } from 'react-toastify';

const ToastInfo = (text, id, time = 5000) => {
  let status = true;
  if (toast.isActive(id)) {
    status = false;
  }
  if (status) {
    return (
      toast.info(text, {
        toastId: id,
        position: "top-right",
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          top: '100px'
        }
      })
    )
  }
}

export default ToastInfo;